import { render } from "./OverlayFooterProvider.vue?vue&type=template&id=77bb81c4"
import script from "./OverlayFooterProvider.vue?vue&type=script&lang=js"
export * from "./OverlayFooterProvider.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__